// Illustrative image per lighting condition, served locally from
// /public/images/lighting/ with SEO-friendly filenames and descriptive alt
// text. These set the mood for a condition; a lighting gradient is blended
// over them so the colour still reads as the condition itself.
//
// The files are downloaded by scripts/download-images.sh (run once). Until
// then the <img> tags simply render nothing over the gradient, so the UI
// still works — the gradient is the fallback.

const BASE = "/images/lighting";

// id -> { file, alt }  (file lives at /images/lighting/<file>)
export const LIGHTING_IMAGE_META = {
  "full-sun":        { file: "full-sun-bright-daylight.jpg",       alt: "Bright midday sun over an open landscape" },
  "partly-cloudy":   { file: "partly-cloudy-sky.jpg",             alt: "Partly cloudy sky with broken sunlight" },
  "overcast":        { file: "overcast-cloudy-sky.jpg",           alt: "Flat, even light under an overcast sky" },
  "shade":           { file: "open-shade-soft-light.jpg",         alt: "Soft, cool light in open shade" },
  "golden-hour":     { file: "golden-hour-warm-light.jpg",        alt: "Warm, low-angle golden hour light" },
  "sunrise":         { file: "sunrise-early-light.jpg",           alt: "Early morning sunrise light" },
  "sunset":          { file: "sunset-warm-sky.jpg",               alt: "Warm sunset sky" },
  "blue-hour":       { file: "blue-hour-twilight.jpg",            alt: "Cool blue-hour twilight after sunset" },
  "backlit":         { file: "backlit-subject-rim-light.jpg",     alt: "Backlit scene with a bright light source behind the subject" },
  "mixed-lighting":  { file: "mixed-lighting-indoor.jpg",         alt: "Mixed indoor lighting with different colour temperatures" },
  "indoor-bright":   { file: "indoor-bright-well-lit.jpg",        alt: "A bright, well-lit indoor space" },
  "low-light":       { file: "low-light-dim-indoor.jpg",          alt: "A dim, low-light indoor scene" },
  "night-sky":       { file: "night-sky-astro.jpg",               alt: "A dark night sky full of stars" },
};

const FALLBACK = { file: "overcast-cloudy-sky.jpg", alt: "Overcast daylight" };

export function imageForLighting(id) {
  const m = LIGHTING_IMAGE_META[id] || FALLBACK;
  return `${BASE}/${m.file}`;
}

export function altForLighting(id, camera, scenario) {
  const m = LIGHTING_IMAGE_META[id] || FALLBACK;
  // When we know the recipe context, make the alt specific and useful.
  if (camera && scenario) return `${scenario} on the ${camera} in ${m.alt.toLowerCase()}`;
  return m.alt;
}

// Kept for backward compatibility with any imports of LIGHTING_IMAGE.
export const LIGHTING_IMAGE = Object.fromEntries(
  Object.keys(LIGHTING_IMAGE_META).map((id) => [id, imageForLighting(id)])
);
